import { fetchPath } from '../../utils/api'
import actions from './actions'

export default {
  namespaced: true,
  state: {},
  methods: {},
  getters: {},
  actions: actions({ fetchPath }),
}
